// src/store/reducers/customerVirtualActivitySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../utils/config';

// 1️⃣ Track an action (fire‑and‑forget, but we capture updated summary)
export const trackVirtualAction = createAsyncThunk(
  'virtualActivity/track',
  async ({ userId, actionType, metadata }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${base_url}/api/user-actions/${userId}`,
        { actionType, metadata },
        { withCredentials: true }
      );
      // returns updated summary doc
      return data.summary;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 2️⃣ Fetch the aggregated summary
export const fetchVirtualSummary = createAsyncThunk(
  'virtualActivity/fetchSummary',
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${base_url}/api/user-actions/${userId}`,
        { withCredentials: true }
      );
      return data.summary;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const slice = createSlice({
  name: 'customerVirtualActivity',
  initialState: {
    summary: null,
    loading: false,
    error: null
  },
  reducers: {
    clearActivityError(state) {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(trackVirtualAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(trackVirtualAction.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.summary = payload;
      })
      .addCase(trackVirtualAction.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(fetchVirtualSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVirtualSummary.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.summary = payload;
      })
      .addCase(fetchVirtualSummary.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  }
});

export const { clearActivityError } = slice.actions;
export default slice.reducer;
